import {Component, Input} from '@angular/core';
import {DriverSummary} from "../../../models/common-data-types";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-driver-list-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './driver-list-card.component.html',
  styleUrl: './driver-list-card.component.scss'
})
export class DriverListCardComponent {
    @Input() driver!: DriverSummary;
}
